import axios from "axios";
import { useEffect, useState } from "react";
import { useValueDebounce } from "src/hooks/useDebounce";

interface Props {
	zipcode?: string;
	house_number?: string | number;
}

function useSearchAddress({ zipcode, house_number }: Props) {
	const path = useValueDebounce(
		zipcode && house_number
			? `zipcode=${zipcode}&house_number=${house_number}`
			: null,
		500
	);
	const [data, setData] = useState({});
	const [loading, setLoading] = useState(false);
	const [place, setPlace] = useState({}) as any;

	const fetchData = async () => {
		if (!path) return;
		setLoading(true);
		const place = await axios
			.get(`/helpers/search-address?${path}`)
			.then(({ data }) => data?.data);
		setLoading(false);
		setData(place);
	};

	useEffect(() => {
		if (path && !loading) {
			fetchData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [path]);

	useEffect(() => {
		if (!zipcode || !house_number) {
			setPlace({});
		}
	}, [zipcode, house_number]);

	useEffect(() => {
		setPlace(data);
	}, [data]);

	return {
		place,
		loading,
	};
}

export default useSearchAddress;
